export default __webpack_public_path__ + "assets/compass.9ead3f7e.svg";